
import { createCustomProperty } from "@/api/customProperty";
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import MIcon from "@/components/MIcon.vue";
import MSelectBox from "@/components/form/MSelectBox.vue";
import MTextField from "@/components/form/MTextField.vue";
import { Options, Vue } from "vue-class-component";
import { CustomProperty, CustomPropertyType } from "@/entities/custom_property";
import { School } from "@/entities/school";
import store from "@/store";
import { saveErrorLog } from "@/api/error";

@Options({
  components: {
    MBaseModal,
    MButton,
    MIcon,
    MSelectBox,
    MTextField
  },
  emits: ["close"],
  props: {
    school: Object,
    customProperties: Array
  }
})
export default class MsAddPropertyModal extends Vue {
  school!: School;
  title = "";
  enteredTitle = false;
  type: CustomPropertyType = "string";
  types: { type: CustomPropertyType; text: string }[] = [
    {
      type: "string",
      text: "テキスト"
    },
    {
      type: "number",
      text: "数字"
    },
    {
      type: "select",
      text: "選択式"
    }
  ];
  choices: string[] = ["", ""];
  shareToAdmin = false;
  showToStudent = false;
  editableByStudent = false;
  multiple = false;
  customProperties: CustomProperty[] = [];

  get existingPropertiesTitlesSet() {
    return new Set(this.customProperties.map(c => c.data.title));
  }

  get validTitleLength() {
    return this.title.length > 0;
  }

  get isTitleUnique(): boolean {
    return this.checkIfTitleIsUnique(this.title);
  }

  get validTitle(): boolean {
    return this.validTitleLength && this.isTitleUnique;
  }

  get validChoices() {
    return this.type !== "select" || this.choices.length >= 2;
  }

  get validData() {
    return this.validTitle && this.validChoices;
  }

  get allEntered(): boolean {
    return this.enteredTitle;
  }

  addChoice() {
    this.choices.push("");
  }

  deleteChoice(index: number) {
    this.choices.splice(index, 1);
  }

  allEnter() {
    this.enteredTitle = true;
  }

  checkIfTitleIsUnique(title: string): boolean {
    return !this.existingPropertiesTitlesSet.has(title);
  }

  async register() {
    this.allEnter();

    if (!this.validData) {
      return;
    }

    const choices = this.type === "select" ? this.choices : [];
    try {
      store.commit("START_LOADING", "登録中...");
      await createCustomProperty(this.school.ref, {
        title: this.title,
        type: this.type,
        shareToAdmin: this.shareToAdmin,
        choices,
        showToStudent: this.showToStudent,
        editableByStudent: this.showToStudent ? this.editableByStudent : false,
        multiple: this.type === "select" ? this.multiple : false
      });
      store.commit("END_LOADING");
    } catch (e) {
      store.commit("END_LOADING");
      alert(`オリジナル情報の作成に失敗しました\n\n${e}`);
      await saveErrorLog(
        store.state.role,
        e.code,
        e.message,
        "Failed to create custom property"
      );
      return;
    }
    this.$router.go(0);
  }

  close() {
    this.$emit("close");
  }
}
